// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M11 1C9.34315 1 8 2.34315 8 4H2V10C3.65685 10 5 11.3431 5 13C5 14.6569 3.65685 16 2 16V22H8C8 20.3431 9.34315 19 11 19C12.6569 19 14 20.3431 14 22H20V16C21.6569 16 23 14.6569 23 13C23 11.3431 21.6569 10 20 10V4H14C14 2.34315 12.6569 1 11 1Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-extension-filled')
export default class ExtensionFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'extension-filled',
    }
  }
}
